export default "__VITE_ASSET__PvBW5f5l__"